import React, { FC } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import agentExperienceConfigResource from 'src/actions/agentExperienceConfig/agentExperienceConfigResource';
import { Body, Row, Section } from 'src/presentation/components/forms/Layout';
import { Button } from 'src/presentation/components/agent_desktop_components';
import Form, { useForm, FormEditorProps } from 'src/presentation/components/forms/Form';
import Footer from 'src/presentation/components/forms/Footer';
import Switch from 'src/presentation/components/forms/Switch';

const UsersSettingsForm: FC<FormEditorProps> = ({ item, errors }) => {
  const history = useHistory();
  const formContext = useForm({
    item,
    errors,
    resetErrors: agentExperienceConfigResource.actions.resetErrors,
    root: 'idle-timing',
    update: agentExperienceConfigResource.effects.replace,
    validate: agentExperienceConfigResource.effects.validate,
  });
  const { onSave, workingState } = formContext;
  const hasChanged = item.allowExternalName !== workingState.allowExternalName;
  const onSaveWrapped = () => {
    onSave();
    history.push({ pathname: '/users', search: history.location.search });
  };
  const onCancel = () => {
    history.push({ pathname: '/users', search: history.location.search });
  };

  const externalNameDescription = (
    <span>
      Allow agents to set an external name, which will be displayed to Customers for external communications instead of
      their full name.{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://help.gladly.com/docs/user-profile-setup">
        Learn more here
      </a>
      .
    </span>
  );

  return (
    <Form context={formContext}>
      <StyledBody data-aid={'editor'}>
        <StyledSection>
          <Row>
            <Switch attr="allowExternalName" label="Activate External Name" description={externalNameDescription} />
          </Row>
        </StyledSection>
      </StyledBody>

      <Footer>
        <Button buttonType={Button.Types.TEXT} data-aid={'editor-cancel'} onClick={onCancel}>
          Cancel
        </Button>
        <Button data-aid={'editor-save'} onClick={onSaveWrapped} disabled={!hasChanged}>
          Save
        </Button>
      </Footer>
    </Form>
  );
};

const StyledBody = styled(Body)`
  max-width: 100%;
  padding-bottom: 0;
  padding-top: 0;
`;

const StyledSection = styled(Section)`
  margin-bottom: 0;
`;

export default UsersSettingsForm;
